<app-breadcrumb *ngIf="!embeddedView"  [master]="'Rozliczenia'" [parentName]="'Konfigurator'" [name]="'Lista'"></app-breadcrumb>
<div class="commission-update-package-list-container " fxLayout="column" fxLayoutGap="15px">
  <div *ngIf="!embeddedView" fxLayout="row" >
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">

      <mat-form-field class="commission-update-package-list-filter">
        <mat-label>ID</mat-label>
        <input matInput placeholder="ID" name="id" [(ngModel)]="initialFilters.id">
      </mat-form-field>


      <app-datepicker
        class="commission-update-package-list-filter"
        label="Data utworzenia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="commission-update-package-list-filter"
        label="Data utworzenia do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

      <app-dict
        [multiple]="false" label="Firma"
        class="commission-update-package-list-filter"
        dictType="company"
        [(ngModel)]="initialFilters.company" name="company"
      ></app-dict>


      <app-dict-insurance-companies
        *ngIf="enableFilters === null || enableFilters.includes('insuranceCompany')"
        [multiple]="true" label="TU"
        class="commission-update-package-list-filter"
        [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
        (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
      ></app-dict-insurance-companies>

      <app-dict
        *ngIf="enableFilters === null || enableFilters.includes('importer')"
        [multiple]="true" label="Importer"
        class="commission-update-package-list-filter"
        [dictType]="'commission_importer_' + (selectedInsuranceCompanies.length > 0 ? selectedInsuranceCompanies[0].key : '')"
        [(ngModel)]="initialFilters.importer" name="importer"
      ></app-dict>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="commission-update-package-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <app-dict-ofwcas
        [multiple]="false" label="OFWCA"
        class="commission-update-package-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <mat-form-field
        class="commission-update-package-list-filter"
        *ngIf="enableFilters === null || enableFilters.includes('riskCode')"
      >
        <mat-label>Kod Ryzyka</mat-label>
        <input matInput placeholder="Kod Ryzyka" name="contains$riskCode" [(ngModel)]="initialFilters.contains$riskCode">
      </mat-form-field>

      <mat-form-field
        class="commission-update-package-list-filter"
        *ngIf="enableFilters === null || enableFilters.includes('riskPack')"
      >
        <mat-label>Kod Grupy</mat-label>
        <input matInput placeholder="Kod Grupy" name="contains$riskPack" [(ngModel)]="initialFilters.contains$riskPack" >
      </mat-form-field>

      <app-dict
        *ngIf="enableFilters === null || enableFilters.includes('risk')"
        [multiple]="true" label="Ryzyko ASF"
        class="commission-update-package-list-filter"
        dictType="internal_risk"
        [(ngModel)]="initialFilters.in$risks" name="in$risks"
      ></app-dict>
      <mat-form-field appearance="standard" class="commission-update-package-list-filter">
        <mat-label>Aktywny </mat-label>
        <mat-select [(ngModel)]="initialFilters.active" name="active">
          <mat-option [value]="null">Wszystkie</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <div *ngIf="!embeddedView" fxLayout="row" fxLayoutGap="15px">
    <div class="add-button" >
      <a  [routerLink]="['/konfigurator/dodaj']">
        <button  (click)="addConfig()"  mat-raised-button color="accent" [disabled]="!(userPermissions | async).settlement.write">
          <mat-icon>add</mat-icon> <span> Dodaj</span>
        </button>
      </a>
    </div>
    <span fxFlex></span>
    <button   *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div fxLayout="column">
    <table mat-table [dataSource]="items" matSort (matSortChange)="sortChanged($event)">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="id"> ID </th>
        <td mat-cell *matCellDef="let element">
            <a class="default-link" [routerLink]="['/konfigurator/szczegoly', element.uuid]">{{element.id}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="createAt">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header="createAt"> Data utworzenia</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/konfigurator/szczegoly', element.uuid]"> {{element.createdAt | date:'y-MM-dd'}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="party">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="party"> Partner/OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.partner">
            Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
          </ng-container>
          <ng-container *ngIf="element.partner && element.ofwca">
            <br>
          </ng-container>
          <ng-container *ngIf="element.ofwca">
            OFWCA: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
          </ng-container>
          <ng-container *ngIf="element.partnerOutsideStructure">
            Partner poza strukturą: {{element.partnerOutsideStructure}}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="company">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="company"> Firma </th>
        <td mat-cell *matCellDef="let element">
          {{element.company?.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceCompany">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="insuranceCompany"> TU <br> (Importer) </th>
        <td mat-cell *matCellDef="let element">
          <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
            {{element.insuranceCompany.name}}
            <ng-container *ngIf="element.importer">
              <br>({{element.importer?.name}})
            </ng-container>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="riskCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="riskCode"> Kod ryzyka </th>
        <td mat-cell *matCellDef="let element">
          {{element.riskCode}}
        </td>
      </ng-container>

      <ng-container matColumnDef="internalRisk">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="risk"> Ryzyko ASF </th>
        <td mat-cell *matCellDef="let element">
          <mat-chip-list>
            <ng-container *ngFor="let risk of element.risks;let last = last">
              <mat-chip color="primary" selected>{{risk.risk.name}}</mat-chip>
            </ng-container>
          </mat-chip-list>
<!--          <ng-container *ngFor="let risk of element.risks;let last = last">-->

<!--            {{risk?.name}}<ng-container *ngIf="!last">, </ng-container>-->
<!--          </ng-container>-->
        </td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="active"> Aktywna</th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [disabled]="true"
            [checked]="element.active" ></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <button (click)="delete(element.uuid)" [disabled]="!(userPermissions | async).settlement.delete || element?.rows.length > 0 " mat-stroked-button color="warn"><mat-icon>delete</mat-icon></button>
<!--          <button (click)="delete(element.uuid)" [disabled]="!(userPermissions | async).settlement.delete" mat-stroked-button color="warn"><mat-icon>delete</mat-icon></button>-->
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="createdBy"> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.createdBy">
            <div class="circular-image">
              <img class="circular-image small-avatar user-list-avatar"
                   [src]="'/rest/sso/api/user/' + element.createdBy.uuid + '/avatar'" (error)="onImgError($event)"
                   alt="Zdjęcie"/>
            </div>
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.createdBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>

</div>
